import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import GoalLogsTableComponent from 'webapp/components/goal/logs/table';

import type { Goal, GoalLog } from 'webapp/models-custom';

interface Args {
	model: Goal;
}

export default class GoalInsightsLogsIndexComponent extends Component<Args> {
	@service('model-manager/goal-logs')
	declare mmGoalLogsService: Service.ModelManager.GoalLogs;
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	@tracked isGoalLogsLoading = false;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		void this.loadLogs();
	}

	get model() {
		return this.args.model;
	}

	get goalLogs() {
		return this.mmGoalLogsService.getLogsForGoal(this.model.id!);
	}

	get isEmpty() {
		return !this.isGoalLogsLoading && this.goalLogs.length === 0;
	}

	get showTitle() {
		return !this.isEmpty && !this.isGoalLogsLoading;
	}

	async loadLogs() {
		this.isGoalLogsLoading = true;

		await this.mmGoalLogsService.requestGoalLogs(this.model.id!);

		this.isGoalLogsLoading = false;
	}

	@action
	editGoalLog(goalLog: GoalLog) {
		this.mmGoalsService.openUpdateProgressPopup(this.model, goalLog);
	}
	<template>
		<div class="goal-insights-logs">
			{{#if this.showTitle}}
				<h3>Progress history</h3>
			{{/if}}
			{{#unless this.isEmpty}}
				<GoalLogsTableComponent
					@model={{this.goalLogs}}
					@isLoading={{this.isGoalLogsLoading}}
					@selectedId={{null}}
					@edit={{this.editGoalLog}}
				/>
			{{/unless}}
		</div>
	</template>
}
